import { ThemeProvider } from '@mui/material';
import { UnpyEvent } from 'domain/event/UnpyEvent';
import { PageLayout } from 'primary/Components/PageLayout/PageLayout';
import { Title } from 'primary/Components/Title/Title';
import { EVENT_CONTEXT } from 'primary/context/event/EventContext';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useTranslate } from 'primary/hooks/useTranslate';
import React, { useContext } from 'react';

import { EventParameterizeForm } from '../../events/forms/EventParameterizeForm';
import { themeParameters } from '../parameters.helper';

export const Parameterize = () => {
  const { event, dispatch } = useContext(EVENT_CONTEXT);
  const { eventRepository } = useContextDependency();
  const t = useTranslate();
  if (!event) return null;

  const onSubmitted = () => {
    eventRepository
      .getEventById(event.id)
      .then((value: UnpyEvent) => dispatch({ type: 'SET_EVENT', event: value }));
  };

  return (
    <div className={'eventAppearence'}>
      <PageLayout>
        <>
          <Title
            title={t('event.parameters.parameterize.title')}
            level={1}
            compensatePadding
            threeQuarter
            bordered
          />
          <ThemeProvider theme={themeParameters}>
            <EventParameterizeForm event={event} onCreated={onSubmitted} />
          </ThemeProvider>
        </>
      </PageLayout>
    </div>
  );
};
